
import { MedmalstatusMdl,MedmalProposal } from "./MedmalProposal";

export class MedmalBindMdl
{
    public schemeList: Array<SchemeMdl>=new Array<SchemeMdl>() ;
    public genderList: Array<GenderMdl>=new Array<GenderMdl>();
    public positionList: Array<PositionHeldMdl>=new Array<PositionHeldMdl>();
    public  indemnityList: Array<IndemnityLevelMdl>=new Array<IndemnityLevelMdl>();
    public natList: Array<NatMdl>=new Array<NatMdl>();
    public hospList: Array<HospitalMdl>=new Array<HospitalMdl>();
    public professionList: Array<ProfessionMdl>=new Array<ProfessionMdl>();
    public  cityList: Array<CityMdl>=new Array<CityMdl>();
    public  prefixList: Array<PrefixMdl>=new Array<PrefixMdl>();
    public bankList: Array<BankMasterMdl>=new Array<BankMasterMdl>();
    public st: MedmalstatusMdl=new MedmalstatusMdl();
    public proposalObj: MedmalProposal=new MedmalProposal();
    public policyNo: string; // CR 1053

    public ExtPeriodList :Array<mdlExtPeriod> = new Array<mdlExtPeriod>();
    public DeductableList  :Array<mdlDeductable> = new Array<mdlDeductable>();
}

export class mdlExtPeriod
{
    public PeriodCode :number;
    public PeriodDescEn :string;
    public PeriodDescAr :string;
}
export class mdlDeductable
{
    public DeductableCode :number;
    public DeductableDesc_Eng :string;
    public DeductableDesc_Ar :string;
}

export class BankMasterMdl
{
    public BankCode: string;
    public BankDesc_Eng: string;
    public  BankDesc_Ar: string;
    public   CbidCode: string;
   // isSameCode: boolean;
}
export class CityMdl
{
    public  CityCode: number;
    public  CityNameEn: string;
    public  CityNameAr: string;
    public  RegCode: string;
    public  RegDescEn: string;
    public  RegDescAr: string;
}
export class GenderMdl
{
    public  GenderCode: string;
    public  GenderDesc_En: string;
    public  GenderDesc_Ar: string;
}
export class HospitalMdl
{
    public   HospitalCode: string;
    public HospitalNameEn: string;
    public  HospitalNameAr: string;
}
export class IndemnityLevelMdl
{
    public IndemnityCode: string;
    public IndemnityDescEn: string;
    public  IndemnityDescAr: string;
    public  IndemnityLimit: number;
    public ProfClassCode :string; //Retro
}
export class NatMdl
{
    public NATCode: string;
    public NATNameEn: string;
    public NATNameAr: string;
}
export class PositionHeldMdl
{
    public PositionHeldId: number;
    public PositionHeldDescEn: string;
    public  PositionHeldDescAr: string;

}
export class PrefixMdl
{
    public  PrefixId: number;
    public  PrefixDescEn: string;
    public  PrefixDescAr: string;
}
export class ProfessionMdl
{
    public  ProfessionCode: string;
    public  ProfessionDesc_Eng: string;
    public  ProfessionDesc_Ar: string;
    public ProfClassCode :string; //Retro
}
export class SchemeMdl
{
    public SchemeCode: string;
    public SchemeDesc: string;
    public SchemeDesc_Ar: string;
    public  LBCode: string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MedmalBindMdl.ts